<template>
  <div id="app">
    <navigation></navigation>
    <hr>
    <router-view></router-view>
    <page-footer></page-footer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import PageFooter from '@/components/PageFooter'
export default {
  name: 'app',
  components: {
    Navigation,
    PageFooter
  }
}
</script>

<style>
body {
/* Verdana, - too wide */
/* Lucida Grande, - cluttered */
/* Droid Serif - ? */
/* Optima, - maybe - seems light */
/* Verdana, - large */
/* Tahoma, - not bad */
  font-family: Tahoma, Georgia, "Times New Roman", Times, serif;
}

h1,h2,h3,h4 {
  font-family: Helvetica, Geneva, Arial, SunSans-Regular, sans-serif;
}

pre,
code,
kbd,
samp,
tt{
  /* font-family:monospace,monospace; */
  font-family: "Andale Mono", "Monotype.com", monospace;
  font-size:1em;
}

*.no-header {
  visibility:hidden;
  overflow:hidden;
  float:left;
  clear: both;
  width: 1px;
  height: 1px;
}

*.small-caps {
  font-variant: small-caps;
}

*.code-block {
  /* font-family: "Courier New", Courier, monospace; */
  /* font-family: "Lucida Console", Monaco, monospace; */
  font-family: "Andale Mono", "Monotype.com", monospace;
  font-size: 10pt;
  width: 480pt;
  padding-left: 0em;
  padding-right: 0em;
  color: black;
  background-color: rgb(215,215,215);
  opacity: 0.7;
}
*.code-block:hover {
  /* font-family: "Courier New", Courier, monospace; */
  /* font-family: "Lucida Console", Monaco, monospace; */
  font-family: "Andale Mono", "Monotype.com", monospace;
  font-size: 10pt;
  width: 480pt;
  padding-left: 0em;
  padding-right: 0em;
  color: black;
  background-color: rgb(215,215,215);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// App.vue?e979eae6